import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { getPasswordPresentation } from "./passwordVisibility.mjs";

export function PasswordField({
  className,
  containerClassName,
  toggleTestId,
  ...inputProps
}) {
  const [visible, setVisible] = useState(false);
  const presentation = getPasswordPresentation(visible);

  return (
    <div className={cn("relative mt-1", containerClassName)}>
      <Input
        {...inputProps}
        type={presentation.type}
        className={cn("pr-12", className)}
      />
      <button
        type="button"
        onClick={() => setVisible((current) => !current)}
        data-testid={toggleTestId}
        aria-label={presentation.label}
        aria-pressed={visible}
        title={presentation.label}
        className="absolute inset-y-0 right-0.5 my-auto min-h-11 min-w-11 flex items-center justify-center rounded-full text-espresso/70 hover:text-espresso hover:bg-espresso/5 focus:outline-none focus:ring-2 focus:ring-espresso/30"
      >
        {visible
          ? <EyeOff size={18} strokeWidth={1.7} aria-hidden="true" />
          : <Eye size={18} strokeWidth={1.7} aria-hidden="true" />}
      </button>
    </div>
  );
}
